import { render, staticRenderFns } from "./ThreadReply.vue?vue&type=template&id=7153629c&scoped=true&"
import script from "./ThreadReply.vue?vue&type=script&lang=js&"
export * from "./ThreadReply.vue?vue&type=script&lang=js&"
import style0 from "./ThreadReply.vue?vue&type=style&index=0&id=7153629c&lang=scss&scoped=true&"
import style1 from "./ThreadReply.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7153629c",
  null
  
)

/* custom blocks */
import block0 from "./ThreadReply.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports